import { Camera, Images, X } from "lucide-react";

// Scelta sorgente per i pulsanti di caricamento della pagina /foto.
export const FotoSourceSheet = ({ label, onCamera, onGallery, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50" onClick={onClose} data-testid="foto-source-sheet">
    <div className="w-full max-w-md rounded-t-3xl bg-white p-5 pb-8 space-y-3" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between">
        <div className="text-base font-bold text-slate-900">{label}</div>
        <button type="button" onClick={onClose} aria-label="Chiudi" data-testid="foto-source-close" className="p-2 -mr-2 text-slate-500"><X className="h-5 w-5" /></button>
      </div>
      <button type="button" onClick={onCamera} data-testid="foto-source-camera"
        className="w-full flex items-center gap-3 rounded-2xl bg-amber-500 active:bg-amber-600 px-4 py-4 text-slate-900 font-bold text-lg">
        <Camera className="h-7 w-7" /> Fotocamera
      </button>
      <button type="button" onClick={onGallery} data-testid="foto-source-gallery"
        className="w-full flex items-center gap-3 rounded-2xl bg-slate-900 active:bg-slate-800 px-4 py-4 text-white font-bold text-lg">
        <Images className="h-7 w-7" /> Galleria
      </button>
    </div>
  </div>
);
